// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1Mwgu","content":"LayoutSettings_content__1thoA"};